// src/modules/LiberaProximaVenda/PopupLiberar.jsx
import React, { useState } from 'react';
import './Popup.css';

const PopupLiberar = ({ onConfirm, documentData, idUser, userName }) => {
  const [isPopupVisible, setIsPopupVisible] = useState(false);

  const handleClick = () => {
    setIsPopupVisible(true);
  };

  const handleConfirm = async () => {
    setIsPopupVisible(false);
    
    // This will be replaced with actual API call when connecting services
    console.log('Release confirmed for:', {
      documentType: documentData.documentType?.id,
      documentNumber: documentData.documentNumber,
      branch: documentData.branch?.id,
      customer: documentData.customer?.code,
      idUser,
      userName,
    });

    window.showAlert('success', 'Document released successfully!');
    
    if (onConfirm) {
      onConfirm('Release');
    }

    // Uncomment when connecting to services:
    /*
    try {
      const url = `/api/release-document?docType=${documentData.documentType?.id}&docNum=${documentData.documentNumber}&branch=${documentData.branch?.id}&idUser=${idUser}&user=${userName}`;
      const response = await fetchData(url, 'GET');

      if (response.ok) {
        window.showAlert('success', 'Document released successfully!');
        if (onConfirm) onConfirm('Release');
      } else {
        window.showAlert('danger', 'Error releasing document.');
      }
    } catch (err) {
      window.showAlert('danger', 'Error releasing document. Check your connection or the data sent.');
    } finally {
      setIsPopupVisible(false);
    }
    */
  };

  const handleCancel = () => {
    setIsPopupVisible(false);
  };

  return (
    <>
      <button className="btn btn-success w-100" onClick={handleClick}>
        Release
      </button>
      {isPopupVisible && (
        <div className="modal-overlay">
          <div className="modal-container">
            <h5>Confirm Release</h5>
            <p>Are you sure you want to release this {documentData.documentType?.name}?</p>
            <div className="document-info-popup">
              <p><strong>Document:</strong> {documentData.documentNumber}</p>
              <p><strong>Customer:</strong> {documentData.customer?.code}/{documentData.customer?.store} - {documentData.customer?.name}</p>
            </div>
            <div className="modal-actions">
              <button className="btn btn-secondary" onClick={handleCancel}>
                Cancel
              </button>
              <button className="btn btn-success" onClick={handleConfirm}>
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PopupLiberar;
